<div
  *ngIf="alertMessageData.Message != ''"
  class="ahe-ui-alert-modal"
  id="okCancelModal"
  role="dialog"
  tabindex="-1"
  aria-label="Deletion successful"
  aria-describedby="alertMessage"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown.escape)="closeModal()"
  aria-modal="true"
>
  <div class="modal-overlay"></div>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body" id="alertMessage">
        {{ alertMessageData.Message }}
      </div>
      <div class="modal-footer">
        <app-button
          buttonText="OK"
          [purpose]="_buttonPurpose.Primary"
          data-dismiss="modal"
          (click)="closeModal()"
        ></app-button>
      </div>
    </div>
  </div>
</div>
